module.exports = __webpack_public_path__ + "img/GazDeBordaux_120X35.ec730836.png";